import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

export interface Representative {
  value: string;
  label: string;
}

@Component({
  selector: "fury-edit-coach",
  templateUrl: "./edit-coach.component.html",
  styleUrls: ["./edit-coach.component.scss"],
})
export class EditCoachComponent {
  representatives: Representative[] = [
    // populate from API
    { value: "testusernewui", label: "testusernewui" },
  ];

  selectedRep: string = "testusernewui";

  constructor(private dialogRef: MatDialogRef<EditCoachComponent>) {}

  submit(): void {
    this.dialogRef.close(this.selectedRep);
  }

  close(): void {
    this.dialogRef.close();
  }
}
